// Copyright (c) 2025 DTCC and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { makeStyles } from 'tss-react/mui';
import { Theme } from '@mui/material';

const gray90 = '#D5D7DD';

export default makeStyles()((theme: Theme) => ({
  inputField: {
    marginTop: 10,
    color: theme.palette.primary.main,
    '& .MuiOutlinedInput-input': {
      color: theme.palette.text.primary,
    },
  },

  inputFieldLabel: {
    color: theme.palette.getContrastText(theme.palette.background.paper),
  },

  inputValidationMessage: {
    color: theme.palette.error.main,
  },
  select: {
    marginTop: 10,
  },
  selectLabel: {
    color: theme.palette.grey[400],
    marginTop: 4,
  },

  fullWidth: {
    width: '100%',
  },

  actionSelect: {
    '& .MuiSelect-select': {
      paddingLeft: 10,
      paddingRight: 0,
      paddingTop: 1,
      paddingBottom: 0,
    },
    fontWeight: 700,
    color: theme.palette.primary.main,
  },

  numberFieldGroup: {
    display: 'flex',
    alignItems: 'stretch',
    width: '100%',
    marginTop: 10,
    border: `1px solid ${gray90}`,
    borderRadius: 4,
    overflow: 'hidden',
    '&:focus-within': {
      border: `2px solid ${theme.palette.secondary.main}`,
    },
  },

  numberFieldGroupError: {
    border: `1px solid ${theme.palette.error.main}`,
    '&:focus-within': {
      border: `2px solid ${theme.palette.error.main}`,
    },
  },

  numberFieldInput: {
    flex: 1,
    border: 'none',
    outline: 'none',
    padding: '8.5px 14px',
    fontFamily: "'Lato', sans-serif",
    fontSize: '0.875rem',
    color: theme.palette.text.primary,
    backgroundColor: 'transparent',
    minWidth: 0,
    '&::placeholder': {
      color: theme.palette.text.secondary,
      opacity: 1,
    },
    '&:disabled': {
      WebkitTextFillColor: theme.palette.text.disabled,
      cursor: 'not-allowed',
    },
  },

  numberFieldButton: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '0 8px',
    border: 'none',
    background: 'transparent',
    cursor: 'pointer',
    color: theme.palette.text.secondary,
    borderLeft: `1px solid ${gray90}`,
    '&:first-of-type': {
      borderLeft: 'none',
      borderRight: `1px solid ${gray90}`,
    },
    '&:hover:not(:disabled)': {
      backgroundColor: theme.palette.action.hover,
    },
    '&:disabled': {
      opacity: 0.38,
      cursor: 'not-allowed',
    },
  },
}));
